import { create } from "zustand";

export type TToastNotificationType = "SUCCESS" | "ERROR" | "WARNING";

export interface IToastNotification {
  id: string;
  type: TToastNotificationType;
  title?: string;
  body: string;
}

type TToastNotificationRequest = Omit<IToastNotification, "id">;

interface IUseToastNotifications {
  notifications: IToastNotification[];
  addNotification(newNotification: TToastNotificationRequest): void;
  removeNotification(notificationId: string): void;
}

export const useToastNotificationsStore = create<IUseToastNotifications>()((set) => ({
  notifications: [],
  addNotification: (newNotification: TToastNotificationRequest) => set(
    (state) => ({
      notifications: [
        ...state.notifications,
        {
          ...newNotification,
          id: crypto.randomUUID(),
        },
      ],
    }),
  ),
  removeNotification: (notificationId: string) => set(
    (state) => ({
      notifications: state.notifications.filter(
        (notification: IToastNotification) => notification.id !== notificationId,
      ),
    }),
  ),
}));

export default useToastNotificationsStore;
